<template>
  
  <div class="row">
    <div class="col-12 mb-2">
      <div class="row">
        <div class="col-6">
          <h2>{{ $t('onlinereservation') }}</h2>
        </div>
        <div class="col-6">
          <p class="text-end">{{ $t('bestprice') }}</p>
          <!-- <p v-html="$t('bookingNotPossible')"></p> -->
          <!-- <p>{{ $t('chooseDates') }}</p> -->
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <div class="datepicker-holder">
          <input
            type="text"
            id="calendar-id-detail-vue"
            class="form-control"
            placeholder="ANREISE – ABREISE"
          />
        </div>
      </div>
    </div>
    <div class="col-12 mt-5">
      <div class="text-danger">
    {{ testData }}
  </div>
    </div>
    <div class="col-12 mt-5">
      <div class="row">
        <div class="col-6">
          <p class="text-uppercase" style="font-size: 17px">{{ $t('chooseAdults') }}</p>
        </div>
        <div class="col-6">
          <p class="text-uppercase" style="font-size: 17px">{{ $t('chooseChildren') }}</p>
        </div>
        <div class="col-6">
          
          <div class="form-group form-group--custom">
            <label for="adults">{{ $t('adults') }}</label>  
            <select
              name="adults"
              class="form-select form-control-sm"
              v-model="adults"
            >
              <option
                v-for="optionAdults in optionsAdults"
                v-bind:key="optionAdults.value"
              >
                {{ optionAdults.text }}
              </option>
            </select>
          </div>
        </div>
        <div
          class="col-6"
          v-for="(select, index) in childAges"
          :key="`ageSelect-${index}`"
        >
          <div v-if="index < 4">
            <div class="form-group form-group--custom">
              <label for="childrenages"
                >{{ $t('age') }} {{ index + 1 }}. {{ $t('child') }}
              </label>
              <select
                @change="changeSelect(select, childAges, index)"
                v-model="select.age"
                name="childrenages"
                class="form-select form-control-sm"
              >
                <option
                  v-for="optionChildren in optionsChildrens"
                  :key="optionChildren.value"
                  :value="optionChildren.value"
                >
                  {{ optionChildren.text }}
                </option>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
    <path d="M15 0L7.5 13L0 0H15Z" fill="#8D87EC"/>
  </svg>
              </select>
            </div>
          </div>
          <div v-else>Bei mehr als 4 Kinder kontktieren sie uns bitte.</div>
        </div>
      </div>
      <div class="row mt-4 justify-content-end">
        <div class="col-md-auto">
          <button
            :class="[
              dateSelected
                ? 'btn btn-primary btn-next'
                : 'btn btn-primary btn-next disabled'
            ]"
            @click="searchRequestParams()"
          >
            {{ $t('check') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HotelDatepicker from 'hotel-datepicker'
import 'hotel-datepicker/dist/css/hotel-datepicker.css'
import fecha from 'fecha'

export default {
  props: {
    preselectedDays: Array,
    disabledDates: Array,
    minPriceDates: Array
  },

  data() {
    return {
      testData: '',
      dateSelected: false,
      range: [],
      newDatePicker: null,
      fecha: fecha,
      adults: 2,
      params: null,
      childAges: [{ age: '' }],
      optionsAdults: [
        { text: '1', value: '1' },
        { text: '2', value: '2' },
        { text: '3', value: '3' },
        { text: '4', value: '4' },
        { text: '5', value: '5' },
        { text: '6', value: '6' },
        { text: '7', value: '7' },
        { text: '8', value: '8' }
      ],
      optionsChildrens: [
        { text: this.$t('age-of-child'), value: '' },
        { text: '0 ' + this.$t('years'), value: '0' },
        { text: '1 ' + this.$t('year'), value: '1' },
        { text: '2 ' + this.$t('years'), value: '2' },
        { text: '3 ' + this.$t('years'), value: '3' },
        { text: '4 ' + this.$t('years'), value: '4' },
        { text: '5 ' + this.$t('years'), value: '5' },
        { text: '6 ' + this.$t('years'), value: '6' },
        { text: '7 ' + this.$t('years'), value: '7' },
        { text: '8 ' + this.$t('years'), value: '8' },
        { text: '9 ' + this.$t('years'), value: '9' },
        { text: '10 ' + this.$t('years'), value: '10' },
        { text: '11 ' + this.$t('years'), value: '11' },
        { text: '12 ' + this.$t('years'), value: '12' },
        { text: '13 ' + this.$t('years'), value: '13' },
        { text: '14 ' + this.$t('years'), value: '14' }
      ]
    }
  },

  mounted() {
    // console.log(this.disabledDates)
    window.fecha = this.fecha
    var helperThis = this
    var tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)

    var picker_options = {
      onSelectRange: function () {
        var s = this.getValue().split(' - ')[0]
        var e = this.getValue().split(' - ')[1]
        this.selectedDates = [s, e]
        helperThis.dateSelected = this.selectedDates.length == 2
      },
      endDate: '2025-11-30',
      animationSpeed: 0.1,
      enableCheckout: true,
      autoClose: false,
      showTopbar: false,
      moveBothMonths: true,
      startDate: tomorrow,
      hoveringTooltip: true,
      preventContainerClose: true,
      format: 'YYYY-MM-DD',
      startOfWeek: 'monday',
      separator: ' - ',
      disabledDates: this.disabledDates,
      // custom function disabled
      // minPriceDates: this.minPriceDates,
      disabledTextLine: this.$t('disabledTooltipText'),
      i18n: {
        night: this.$t('night'),
        nights: this.$t('nights'),
        'day-names-short': [
          this.$t('sun'),
          this.$t('mon'),
          this.$t('tue'),
          this.$t('wed'),
          this.$t('thur'),
          this.$t('fri'),
          this.$t('sat')
        ],
        'month-names': [
          this.$t('january'),
          this.$t('february'),
          this.$t('march'),
          this.$t('april'),
          this.$t('may'),
          this.$t('june'),
          this.$t('july'),
          this.$t('august'),
          this.$t('september'),
          this.$t('october'),
          this.$t('november'),
          this.$t('december')
        ]
      }
    }
    this.DatePickerInput = document.getElementById('calendar-id-detail-vue')
    this.newDatePicker = new HotelDatepicker(
      this.DatePickerInput,
      picker_options
    )
    this.newDatePicker.open()
  },

  computed: {
    isDateSelected() {
      return this.newDatePicker != null &&
        this.newDatePicker.getValue().split(' - ').length == 2
        ? true
        : false
    }
  },

  methods: {
    isDateSelectedMethod() {
      if (this.newDatePicker != null) {
        this.range = this.newDatePicker.getValue().split(' - ')
        if (this.range.length == 2) {
          return true
        } else {
          this.testData = 'Bitte den Reisezeitraum wählen.'
          return false
        }
      }
    },

    changeSelect(value, fieldType, idx) {
      if (fieldType.length == idx + 1) {
        fieldType.push({ age: '' })
      }
      if (value.age == '' && fieldType.length > 1) {
        fieldType.splice(idx, 1)
      }
    },

    searchRequestParams() {
      if (this.isDateSelectedMethod() === true) {
        var start = this.range[0]
        var end = this.range[1]

        var a = []
        this.childAges.forEach((item) => {
          a.push(item.age)
          //console.log(a);
        })
        var childrenPrams = a.filter(function (value) {
          return value != ''
        })

        this.params = {
          dateFrom: start,
          dateTo: end,
          adults: this.adults,
          children: childrenPrams.join(';'),
          code: '',
          clearbasket: 'true'
        }
        this.trackEvent(
          'Booking',
          'Calendar Search Clicked',
          start + ' - ' + end
        )
        this.$emit('searchRooms', this.params)
        // this.testData = this.params;
      } else {
        this.testData = this.$t('alert-date')
      }
    }
  }
}
</script>
